import { useEffect, useState } from "react"
// functions
import {status_color_flag} from "../../Suport_functions"

export default function Segundo_piso({ sala_resaltada, colores }) {
    const [Hall_Segundo_Piso, Set_Hall_Segundo_Piso] = useState({ color: colores.color_sala_desactivada, display: "none" })
    const [Sanitario_Segundo_Piso, Set_Sanitario_Segundo_Piso] = useState({ color: colores.color_sala_desactivada, display: "none" })
    const [Sala_Vendimia, Set_Sala_Vendimia] = useState({ color: colores.color_sala_desactivada, display: "none" })
    const [Sala_Puente_Del_Inca, Set_Sala_Puente_Del_Inca] = useState({ color: colores.color_sala_desactivada, display: "none" })
    const [Sala_Horcones, Set_Sala_Horcones] = useState({ color: colores.color_sala_desactivada, display: "none" })
    const [Sala_Plumerillo, Set_Sala_Plumerillo] = useState({ color: colores.color_sala_desactivada, display: "none" })

    useEffect(() => {
        Set_Hall_Segundo_Piso(status_color_flag("Hall_Segundo_Piso", sala_resaltada, colores));
        Set_Sanitario_Segundo_Piso(status_color_flag("Sanitario_Segundo_Piso", sala_resaltada, colores));
        Set_Sala_Vendimia(status_color_flag("Sala_Vendimia", sala_resaltada, colores));
        Set_Sala_Puente_Del_Inca(status_color_flag("Sala_Puente_Del_Inca", sala_resaltada, colores));
        Set_Sala_Horcones(status_color_flag("Sala_Horcones", sala_resaltada, colores));
        Set_Sala_Plumerillo(status_color_flag("Sala_Raizen", sala_resaltada, colores));
    }, [sala_resaltada, colores]);
    return (
        <svg
            id="segundo_piso"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 1683.8 1190.6"
            style={{
                enableBackground: "new 0 0 1683.8 1190.6",
            }}
            xmlSpace="preserve"
        >
            <style>
                {
                    `#segundo_piso .st2{fill:#1a1a18}
                    #segundo_piso .st3{font-family:'Montserrat-SemiBold'}
                    #segundo_piso .st9{font-size:48.2794px}
                    #segundo_piso .st10{fill:#221e73}
                    #segundo_piso .st11{fill:#fff}
                    #segundo_piso .st17{font-size:27.2669px}
                    #segundo_piso .st21{font-size:47.672px}
                    #segundo_piso .st22{fill:${Set_Hall_Segundo_Piso.color}}`
                }
            </style>
            <g id="hall">
                <path
                    id="marco_espacio_vacio"
                    style={{
                        fill: "none",
                        stroke: "#1a1a18",
                        strokeWidth: 6,
                        strokeMiterlimit: 22.9256,
                    }}
                    d="M320.6 463.8h610.2v472.1H320.6z"
                />
                <path
                    id="color_hall"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: Hall_Segundo_Piso.color,
                        stroke: "#000",
                        strokeWidth: 6,
                        strokeMiterlimit: 22.9256,
                    }}
                    d="M118.8 233h1426.6v702.3l-614.5.5v-472H320.6l-.4 471.5H118.8z"
                />
                <text
                    transform="translate(698.332 392.753)"
                    className="st2 st3"
                    style={{
                        fontSize: "27.2734px",
                    }}
                >
                    {"HALL DE EXPOSICI\xD3N"}
                </text>
            </g>
            <g id="asensor">
                <path
                    id="color_ascensor_1_"
                    style={{
                        fill: "#78c8cc",
                        stroke: "#1a1a18",
                        strokeWidth: 6,
                        strokeMiterlimit: 22.9256,
                    }}
                    d="M916.8 935.6h92.2v43.5l-13.3 13h-63.2l-15.7-12.8z"
                />
                <text
                    transform="translate(920.506 967.94)"
                    className="st2 st3"
                    style={{
                        fontSize: "17.8046px",
                    }}
                >
                    {"Ascensor"}
                </text>
            </g>
            <g id="sala_vendimia">
                <path
                    id="color_sala_vendimia"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: Sala_Vendimia.color,
                        stroke: "#1a1a18",
                        strokeWidth: 6,
                        strokeMiterlimit: 10,
                    }}
                    d="M1545.4 935.3H992.9V702.6h552.5z"
                />
                <path
                    id="separacion_deposito_y_sala_vendimia"
                    style={{
                        fill: "none",
                        stroke: "#1d1d1b",
                        strokeWidth: 6,
                        strokeMiterlimit: 22.9256,
                    }}
                    d="M1134.3 704.9v230.4h9.3"
                />
                <text transform="translate(1261.404 797)" className="st2 st3 st9">
                    {"SALA"}
                </text>
                <text transform="translate(1183.044 854.94)" className="st2 st3 st9">
                    {"VENDIMIA I"}
                </text>
                <g id="bandera_vendimia" display={Sala_Vendimia.display}>
                    <path
                        id="palo_1_"
                        d="M1368.1 864.5c-1.1-.2-1.8-1.3-1.6-2.4l27.9-146.8c.2-1.1 1.3-1.8 2.4-1.6 1.1.2 1.8 1.3 1.6 2.4l-27.9 146.8c-.2 1.1-1.3 1.8-2.4 1.6z"
                    />
                    <path
                        id="fondo_bandera_1_"
                        className="st10"
                        d="M1500.3 821.1c-6.3 1.5-17.8 4.4-29.5-.7-28-12-59.3-26.1-89.7-22 4.5-23.8 9.1-47.7 13.6-71.5 40-2.3 80.2 20.2 119.2 22.6-4.6 23.9-9.1 47.7-13.6 71.6z"
                    />
                    <path
                        id="borde_bandera_1_"
                        d="M1478.7 824c-4.5-.8-9.1-2.3-13.7-4.2l-2.3-1c-25.8-11-52.4-22.3-81.4-18.4-.6.1-1.3-.1-1.7-.6s-.6-1.1-.5-1.8l13.6-71.5c.2-.9.9-1.6 1.9-1.6 22.6-1.3 45.4 5.2 67.4 11.5 17.2 4.9 35 10 52.1 11.1.6 0 1.1.3 1.5.8s.5 1 .4 1.6l-13.6 71.5c-.1.7-.6 1.3-1.3 1.5-6.7 2.3-14.3 2.7-22.4 1.1zm-65.4-26.4c17.7 3.4 34.5 10.5 51 17.6l2.3 1c11.6 5 22.9 6.2 31.9 3.4l12.9-68.1c-16.8-1.4-34-6.3-50.6-11.1-21.2-6.1-43.1-12.3-64.5-11.5l-12.8 67.3c10.3-1.2 20.2-.5 29.8 1.4zm86.9 23.5z"
                    />
                    <path
                        className="st11"
                        d="m1408.4 765.2-.5 2.5c-4.3-.4-6.4-.4-10.8-.2 1-5.4 1.5-8.1 2.6-13.5 4.3-.2 6.4-.1 10.5.2l-.5 2.5c-2.9-.2-4.4-.3-7.3-.3-.2 1.2-.3 1.8-.6 2.9 2.6 0 3.9 0 6.5.2-.2 1-.3 1.5-.5 2.4-2.6-.2-3.9-.2-6.5-.2-.2 1.3-.4 1.9-.6 3.1 3.2.1 4.7.2 7.7.4zM1411.2 767.9c-.8-.3-1.4-.6-1.8-1 .6-.8.9-1.2 1.4-2.1.4.3.9.7 1.6.9.6.3 1.3.4 1.9.5 1.3.2 2 0 2.1-.7.1-.3-.1-.5-.4-.7s-.9-.4-1.6-.6c-.8-.2-1.5-.5-2-.7s-1-.6-1.3-1.1c-.3-.5-.4-1.1-.3-1.9.1-.7.4-1.2.9-1.7s1.1-.8 1.9-1 1.7-.2 2.7-.1c.7.1 1.5.3 2.2.6.7.3 1.3.6 1.7 1-.6.8-.8 1.2-1.4 2-.8-.7-1.8-1.1-2.9-1.3-.6-.1-1.2-.1-1.5.1-.4.1-.6.3-.6.6-.1.3.1.6.4.7.3.2.9.4 1.6.6.8.3 1.5.5 2 .8s.9.6 1.2 1.1c.3.5.4 1.1.3 1.9-.1.6-.4 1.2-.9 1.6-.5.4-1.1.7-1.9.9-.8.2-1.7.2-2.7 0-.9.1-1.8-.1-2.6-.4zM1427.3 770.5c-.3.1-.7.2-1.2.2-.4 0-.9 0-1.4-.2-1.2-.3-2.1-.8-2.7-1.6-.6-.8-.7-1.8-.5-3 .3-1.7.5-2.6.8-4.3-.6-.1-1-.2-1.6-.3.2-.9.3-1.4.4-2.3.6.1 1 .2 1.6.3l.5-2.5c1.2.2 1.8.4 3 .6l-.5 2.5c1 .2 1.5.3 2.6.6-.2.9-.3 1.4-.4 2.3-1-.2-1.5-.4-2.6-.6-.3 1.7-.5 2.5-.8 4.2-.1.4 0 .8.1 1.1.2.3.5.5.9.6.5.1.9.1 1.3-.1.2 1.1.3 1.6.5 2.5zM1438.4 764.2c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.6-.8-.2-1.4-.5-2-1-.5-.4-.9-.9-1.1-1.5-.2-.6-.3-1.1-.2-1.7.2-1 .7-1.6 1.5-2 .8-.4 2-.4 3.5.1.9.3 1.4.4 2.4.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.1-1.1-.2-1.7-.2s-1.1.2-1.5.4c-.3-1-.4-1.4-.7-2.4.6-.3 1.4-.4 2.2-.4.8 0 1.6.1 2.5.3 1.8.5 2.9 1.2 3.6 2.2zm-3.9 6.4c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.3-2-.6-1.2-.3-1.9-.1-2.1.7-.1.4 0 .7.3 1 .3.3.6.5 1.2.7.5.3 1 .3 1.4.1zM1441.6 774.9c-.8-.5-1.4-.9-1.8-1.4.6-.7.8-1.1 1.4-1.9.4.4.9.8 1.5 1.2s1.2.7 1.8.9c1.2.4 1.9.3 2-.4.1-.3-.1-.6-.4-.8-.3-.2-.8-.5-1.5-.8-.8-.4-1.5-.7-2-1.1-.5-.3-.9-.8-1.2-1.3-.3-.5-.4-1.2-.3-2 .1-.7.4-1.2.9-1.6.5-.4 1.1-.6 1.9-.7.8-.1 1.6.1 2.6.4.7.2 1.4.5 2.1.9.7.4 1.2.8 1.6 1.2-.6.7-.8 1.1-1.4 1.8-.8-.8-1.7-1.4-2.8-1.7-.6-.2-1.1-.3-1.5-.2-.3.1-.6.3-.6.5-.1.3.1.6.4.8.3.2.8.5 1.6.9s1.5.8 2 1.1.9.8 1.2 1.3c.3.5.4 1.2.2 2-.1.6-.4 1.2-.9 1.5-.5.4-1.1.6-1.9.7-.8 0-1.7-.1-2.7-.4-.7-.1-1.5-.5-2.2-.9zM1465.5 772.4c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.5-.8-.2-1.4-.6-2-1-.5-.4-.9-1-1.1-1.5-.2-.6-.3-1.2-.1-1.8.2-1 .7-1.6 1.5-2 .8-.3 2-.3 3.5.2.9.3 1.4.4 2.3.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.2-1.1-.2-1.6-.2-.6 0-1 .1-1.5.3-.3-1-.4-1.5-.7-2.4.6-.2 1.4-.3 2.2-.3.8 0 1.6.1 2.5.4 1.6.5 2.8 1.2 3.5 2.2zm-3.9 6.5c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.4-2-.6-1.2-.4-1.9-.1-2 .7-.1.4 0 .7.3 1.1.3.3.6.5 1.2.7.4.1.9.1 1.3 0zM1480.2 774.9c-1.1 5.7-1.6 8.5-2.7 14.1-1.2-.2-1.8-.3-3-.6.4-1.9.6-2.9.9-4.8-.9.7-2 .9-3.3.6-1-.2-1.8-.7-2.5-1.3-.7-.6-1.2-1.4-1.5-2.3-.3-.9-.3-1.9-.1-3 .2-1.1.6-1.9 1.2-2.6.6-.7 1.3-1.2 2.2-1.4.9-.2 1.8-.2 2.8 0 1.4.3 2.4 1 3 2.1.1-.5.1-.7.2-1.2 1.1.1 1.7.2 2.8.4zm-5.1 6.6c.6-.4 1-1.1 1.1-1.9.2-.9 0-1.6-.4-2.3-.4-.6-1-1-1.7-1.2-.8-.2-1.4-.1-2 .3-.6.4-1 1-1.1 1.9-.2.9-.1 1.6.3 2.3.4.6 1 1.1 1.7 1.2.9.2 1.5.1 2.1-.3zM1493.6 776.6c-.8 4.2-1.2 6.2-2 10.4-1.2-.1-1.8-.1-2.9-.2.1-.5.1-.7.2-1.2-.5.4-1 .7-1.7.9-.6.2-1.2.2-1.9.1-1.4-.2-2.4-.7-3.1-1.6-.7-.9-.8-2.1-.5-3.7.4-2.3.7-3.5 1.1-5.9l3 .5c-.4 2.2-.6 3.3-1 5.4-.3 1.7.2 2.6 1.7 2.8.7.1 1.4-.1 1.9-.5s.9-1.1 1.1-2c.4-2.1.6-3.1 1-5.1 1.3 0 1.9 0 3.1.1zM1499.7 772.7c1.3 0 2 0 3.4-.1-1.7 1.2-2.5 1.7-4.2 2.9h-2.4c1.3-1.2 1.9-1.7 3.2-2.8zm-3.2 4h3.1c-.8 4.2-1.2 6.2-2 10.4h-3.1c.8-4.1 1.2-6.2 2-10.4z"
                    />
                </g>
            </g>
            <g id="depositos">
                <path
                    id="color_deposito_izquierdo"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: colores.color_sala_desactivada,
                        stroke: "#1a1a18",
                        strokeWidth: 6,
                        strokeMiterlimit: 10,
                    }}
                    d="M118.8 554.3h146.5v146.9H118.8z"
                />
                <path
                    id="deposito_derecho"
                    style={{
                        fill: colores.color_sala_desactivada,
                        stroke: "#1d1d1b",
                        strokeWidth: 1.0001,
                        strokeLinejoin: "bevel",
                        strokeMiterlimit: 22.9256,
                    }}
                    d="M995.9 704.9h135.3v227.8H995.9z"
                />
            </g>
            <g id="sanitario">
                <path
                    id="color_sanitario"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: "#f6a031",
                        stroke: "#1d1d1b",
                        strokeWidth: 6,
                        strokeMiterlimit: 10,
                    }}
                    d="M118.8 935.8H319.7V701.2H118.8z"
                />
                <text
                    transform="matrix(.6681 0 0 1 132.096 828.599)"
                    className="st2 st3"
                    style={{
                        fontSize: "42.2299px",
                    }}
                >
                    {"SANITARIO"}
                </text>
            </g>
            <g id="sala_puente_del_inca">
                <path
                    id="color_sala_puente_del_inca"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: Sala_Puente_Del_Inca.color,
                        stroke: "#1a1a18",
                        strokeWidth: 6,
                        strokeMiterlimit: 10,
                    }}
                    d="M118.8 554.3h146.5V233H118.8z"
                />
                <text transform="translate(154.913 325.338)" className="st2 st3 st17">
                    {"SALA"}
                </text>
                <text transform="translate(133.903 358.058)" className="st2 st3 st17">
                    {"PUENTE"}
                </text>
                <text transform="translate(163.513 390.778)" className="st2 st3 st17">
                    {"DEL"}
                </text>
                <text transform="translate(156.563 423.498)" className="st2 st3 st17">
                    {"INCA"}
                </text>
                <g id="bandera_puente_del_inca" display={Sala_Puente_Del_Inca.display}>
                    <path
                        id="palo_4_"
                        d="M146.1 298.9c-1.1-.2-1.8-1.3-1.6-2.4l27.9-146.8c.2-1.1 1.3-1.8 2.4-1.6 1.1.2 1.8 1.3 1.6 2.4l-27.9 146.8c-.2 1.1-1.3 1.8-2.4 1.6z"
                    />
                    <path
                        id="fondo_bandera_4_"
                        className="st10"
                        d="M278.3 255.5c-6.3 1.5-17.8 4.4-29.5-.7-28-12-59.3-26.1-89.7-22 4.5-23.8 9.1-47.7 13.6-71.5 40-2.3 80.2 20.2 119.2 22.6-4.6 23.9-9.1 47.7-13.6 71.6z"
                    />
                    <path
                        id="borde_bandera_4_"
                        d="M256.7 258.4c-4.5-.8-9.1-2.3-13.7-4.2l-2.3-1c-25.8-11-52.4-22.3-81.4-18.4-.6.1-1.3-.1-1.7-.6s-.6-1.1-.5-1.8l13.6-71.5c.2-.9.9-1.6 1.9-1.6 22.6-1.3 45.4 5.2 67.4 11.5 17.2 4.9 35 10 52.1 11.1.6 0 1.1.3 1.5.8s.5 1 .4 1.6l-13.6 71.5c-.1.7-.6 1.3-1.3 1.5-6.7 2.3-14.3 2.7-22.4 1.1zM191.3 232c17.7 3.4 34.5 10.5 51 17.6l2.3 1c11.6 5 22.9 6.2 31.9 3.4l12.9-68.1c-16.8-1.4-34-6.3-50.6-11.1-21.2-6.1-43.1-12.3-64.5-11.5l-12.8 67.3c10.3-1.2 20.2-.5 29.8 1.4zm86.9 23.5z"
                    />
                    <path
                        className="st11"
                        d="m186.4 199.6-.5 2.5c-4.3-.4-6.4-.4-10.8-.2 1-5.4 1.5-8.1 2.6-13.5 4.3-.2 6.4-.1 10.5.2l-.5 2.5c-2.9-.2-4.4-.3-7.3-.3-.2 1.2-.3 1.8-.6 2.9 2.6 0 3.9 0 6.5.2-.2 1-.3 1.5-.5 2.4-2.6-.2-3.9-.2-6.5-.2-.2 1.3-.4 1.9-.6 3.1 3.2.1 4.7.2 7.7.4zM189.2 202.3c-.8-.3-1.4-.6-1.8-1 .6-.8.9-1.2 1.4-2.1.4.3.9.7 1.6.9.6.3 1.3.4 1.9.5 1.3.2 2 0 2.1-.7.1-.3-.1-.5-.4-.7-.3-.2-.9-.4-1.6-.6-.8-.2-1.5-.5-2-.7s-1-.6-1.3-1.1-.4-1.1-.3-1.9c.1-.7.4-1.2.9-1.7s1.1-.8 1.9-1 1.7-.2 2.7-.1c.7.1 1.5.3 2.2.6.7.3 1.3.6 1.7 1-.6.8-.8 1.2-1.4 2-.8-.7-1.8-1.1-2.9-1.3-.6-.1-1.2-.1-1.5.1-.4.1-.6.3-.6.6-.1.3.1.6.4.7.3.2.9.4 1.6.6.8.3 1.5.5 2 .8s.9.6 1.2 1.1.4 1.1.3 1.9c-.1.6-.4 1.2-.9 1.6s-1.1.7-1.9.9c-.8.2-1.7.2-2.7 0-.9.1-1.8-.1-2.6-.4zM205.3 204.9c-.3.1-.7.2-1.2.2-.4 0-.9 0-1.4-.2-1.2-.3-2.1-.8-2.7-1.6-.6-.8-.7-1.8-.5-3 .3-1.7.5-2.6.8-4.3-.6-.1-1-.2-1.6-.3.2-.9.3-1.4.4-2.3.6.1 1 .2 1.6.3l.5-2.5c1.2.2 1.8.4 3 .6l-.5 2.5c1 .2 1.5.3 2.6.6-.2.9-.3 1.4-.4 2.3-1-.2-1.5-.4-2.6-.6-.3 1.7-.5 2.5-.8 4.2-.1.4 0 .8.1 1.1.2.3.5.5.9.6.5.1.9.1 1.3-.1.2 1.1.3 1.6.5 2.5zM216.4 198.6c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.6-.8-.2-1.4-.5-2-1-.5-.4-.9-.9-1.1-1.5-.2-.6-.3-1.1-.2-1.7.2-1 .7-1.6 1.5-2s2-.4 3.5.1c.9.3 1.4.4 2.4.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.1-1.1-.2-1.7-.2-.6 0-1.1.2-1.5.4-.3-1-.4-1.4-.7-2.4.6-.3 1.4-.4 2.2-.4s1.6.1 2.5.3c1.8.5 2.9 1.2 3.6 2.2zm-3.9 6.4c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.3-2-.6-1.2-.3-1.9-.1-2.1.7-.1.4 0 .7.3 1s.6.5 1.2.7c.5.3 1 .3 1.4.1zM219.6 209.3c-.8-.5-1.4-.9-1.8-1.4.6-.7.8-1.1 1.4-1.9.4.4.9.8 1.5 1.2.6.4 1.2.7 1.8.9 1.2.4 1.9.3 2-.4.1-.3-.1-.6-.4-.8-.3-.2-.8-.5-1.5-.8-.8-.4-1.5-.7-2-1.1-.5-.3-.9-.8-1.2-1.3s-.4-1.2-.3-2c.1-.7.4-1.2.9-1.6s1.1-.6 1.9-.7 1.6.1 2.6.4c.7.2 1.4.5 2.1.9.7.4 1.2.8 1.6 1.2-.6.7-.8 1.1-1.4 1.8-.8-.8-1.7-1.4-2.8-1.7-.6-.2-1.1-.3-1.5-.2-.3.1-.6.3-.6.5-.1.3.1.6.4.8.3.2.8.5 1.6.9s1.5.8 2 1.1c.5.3.9.8 1.2 1.3s.4 1.2.2 2c-.1.6-.4 1.2-.9 1.5-.5.4-1.1.6-1.9.7-.8 0-1.7-.1-2.7-.4-.7-.1-1.5-.5-2.2-.9zM243.5 206.8c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.5-.8-.2-1.4-.6-2-1-.5-.4-.9-1-1.1-1.5-.2-.6-.3-1.2-.1-1.8.2-1 .7-1.6 1.5-2 .8-.3 2-.3 3.5.2.9.3 1.4.4 2.3.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.2-1.1-.2-1.6-.2-.6 0-1 .1-1.5.3-.3-1-.4-1.5-.7-2.4.6-.2 1.4-.3 2.2-.3s1.6.1 2.5.4c1.6.5 2.8 1.2 3.5 2.2zm-3.9 6.5c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.4-2-.6-1.2-.4-1.9-.1-2 .7-.1.4 0 .7.3 1.1.3.3.6.5 1.2.7.4.1.9.1 1.3 0zM258.2 209.3c-1.1 5.7-1.6 8.5-2.7 14.1-1.2-.2-1.8-.3-3-.6.4-1.9.6-2.9.9-4.8-.9.7-2 .9-3.3.6-1-.2-1.8-.7-2.5-1.3-.7-.6-1.2-1.4-1.5-2.3s-.3-1.9-.1-3 .6-1.9 1.2-2.6c.6-.7 1.3-1.2 2.2-1.4.9-.2 1.8-.2 2.8 0 1.4.3 2.4 1 3 2.1.1-.5.1-.7.2-1.2 1.1.1 1.7.2 2.8.4zm-5.1 6.6c.6-.4 1-1.1 1.1-1.9.2-.9 0-1.6-.4-2.3-.4-.6-1-1-1.7-1.2-.8-.2-1.4-.1-2 .3s-1 1-1.1 1.9c-.2.9-.1 1.6.3 2.3.4.6 1 1.1 1.7 1.2.9.2 1.5.1 2.1-.3zM271.6 211c-.8 4.2-1.2 6.2-2 10.4-1.2-.1-1.8-.1-2.9-.2.1-.5.1-.7.2-1.2-.5.4-1 .7-1.7.9-.6.2-1.2.2-1.9.1-1.4-.2-2.4-.7-3.1-1.6-.7-.9-.8-2.1-.5-3.7.4-2.3.7-3.5 1.1-5.9l3 .5c-.4 2.2-.6 3.3-1 5.4-.3 1.7.2 2.6 1.7 2.8.7.1 1.4-.1 1.9-.5s.9-1.1 1.1-2c.4-2.1.6-3.1 1-5.1 1.3 0 1.9 0 3.1.1zM277.7 207.1c1.3 0 2 0 3.4-.1-1.7 1.2-2.5 1.7-4.2 2.9h-2.4c1.3-1.2 1.9-1.7 3.2-2.8zm-3.2 4h3.1c-.8 4.2-1.2 6.2-2 10.4h-3.1c.8-4.1 1.2-6.2 2-10.4z"
                    />
                </g>
            </g>
            <g id="sala_horcones">
                <path
                    id="color_sala_horcones"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: Sala_Horcones.color,
                        stroke: "#1a1a18",
                        strokeWidth: 6,
                        strokeMiterlimit: 10,
                    }}
                    d="M265.3 404.8h406.2V233H265.3z"
                />
                <text
                    transform="translate(333.368 315.236)"
                    className="st2 st3"
                    style={{
                        fontSize: "33.6659px",
                    }}
                >
                    {"SALA HORCONES"}
                </text>
                <g id="bandera_horcones" display={Sala_Horcones.display}>
                    <path
                        id="palo_3_"
                        d="M433.5 323c-1.1-.2-1.8-1.3-1.6-2.4l27.9-146.8c.2-1.1 1.3-1.8 2.4-1.6 1.1.2 1.8 1.3 1.6 2.4l-27.9 146.8c-.2 1.1-1.3 1.8-2.4 1.6z"
                    />
                    <path
                        id="fondo_bandera_3_"
                        className="st10"
                        d="M565.7 279.6c-6.3 1.5-17.8 4.4-29.5-.7-28-12-59.3-26.1-89.7-22 4.5-23.8 9.1-47.7 13.6-71.5 40-2.3 80.2 20.2 119.2 22.6-4.6 23.9-9.1 47.7-13.6 71.6z"
                    />
                    <path
                        id="borde_bandera_3_"
                        d="M544.1 282.5c-4.5-.8-9.1-2.3-13.7-4.2l-2.3-1c-25.8-11-52.4-22.3-81.4-18.4-.6.1-1.3-.1-1.7-.6s-.6-1.1-.5-1.8l13.6-71.5c.2-.9.9-1.6 1.9-1.6 22.6-1.3 45.4 5.2 67.4 11.5 17.2 4.9 35 10 52.1 11.1.6 0 1.1.3 1.5.8s.5 1 .4 1.6l-13.6 71.5c-.1.7-.6 1.3-1.3 1.5-6.7 2.3-14.3 2.7-22.4 1.1zm-65.4-26.4c17.7 3.4 34.5 10.5 51 17.6l2.3 1c11.6 5 22.9 6.2 31.9 3.4l12.9-68.1c-16.8-1.4-34-6.3-50.6-11.1-21.2-6.1-43.1-12.3-64.5-11.5l-12.8 67.3c10.3-1.2 20.2-.5 29.8 1.4zm86.9 23.5z"
                    />
                    <path
                        className="st11"
                        d="m473.8 223.7-.5 2.5c-4.3-.4-6.4-.4-10.8-.2 1-5.4 1.5-8.1 2.6-13.5 4.3-.2 6.4-.1 10.5.2l-.5 2.5c-2.9-.2-4.4-.3-7.3-.3-.2 1.2-.3 1.8-.6 2.9 2.6 0 3.9 0 6.5.2-.2 1-.3 1.5-.5 2.4-2.6-.2-3.9-.2-6.5-.2-.2 1.3-.4 1.9-.6 3.1 3.2.1 4.7.2 7.7.4zM476.6 226.4c-.8-.3-1.4-.6-1.8-1 .6-.8.9-1.2 1.4-2.1.4.3.9.7 1.6.9.6.3 1.3.4 1.9.5 1.3.2 2 0 2.1-.7.1-.3-.1-.5-.4-.7-.3-.2-.9-.4-1.6-.6-.8-.2-1.5-.5-2-.7s-1-.6-1.3-1.1-.4-1.1-.3-1.9c.1-.7.4-1.2.9-1.7s1.1-.8 1.9-1 1.7-.2 2.7-.1c.7.1 1.5.3 2.2.6.7.3 1.3.6 1.7 1-.6.8-.8 1.2-1.4 2-.8-.7-1.8-1.1-2.9-1.3-.6-.1-1.2-.1-1.5.1-.4.1-.6.3-.6.6-.1.3.1.6.4.7.3.2.9.4 1.6.6.8.3 1.5.5 2 .8s.9.6 1.2 1.1.4 1.1.3 1.9c-.1.6-.4 1.2-.9 1.6s-1.1.7-1.9.9c-.8.2-1.7.2-2.7 0-.9.1-1.8-.1-2.6-.4zM492.7 229c-.3.1-.7.2-1.2.2-.4 0-.9 0-1.4-.2-1.2-.3-2.1-.8-2.7-1.6-.6-.8-.7-1.8-.5-3 .3-1.7.5-2.6.8-4.3-.6-.1-1-.2-1.6-.3.2-.9.3-1.4.4-2.3.6.1 1 .2 1.6.3l.5-2.5c1.2.2 1.8.4 3 .6l-.5 2.5c1 .2 1.5.3 2.6.6-.2.9-.3 1.4-.4 2.3-1-.2-1.5-.4-2.6-.6-.3 1.7-.5 2.5-.8 4.2-.1.4 0 .8.1 1.1.2.3.5.5.9.6.5.1.9.1 1.3-.1.2 1.1.3 1.6.5 2.5zM503.8 222.7c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.6-.8-.2-1.4-.5-2-1-.5-.4-.9-.9-1.1-1.5-.2-.6-.3-1.1-.2-1.7.2-1 .7-1.6 1.5-2s2-.4 3.5.1c.9.3 1.4.4 2.4.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.1-1.1-.2-1.7-.2-.6 0-1.1.2-1.5.4-.3-1-.4-1.4-.7-2.4.6-.3 1.4-.4 2.2-.4s1.6.1 2.5.3c1.8.5 2.9 1.2 3.6 2.2zm-3.9 6.4c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.3-2-.6-1.2-.3-1.9-.1-2.1.7-.1.4 0 .7.3 1s.6.5 1.2.7c.5.3 1 .3 1.4.1zM507 233.4c-.8-.5-1.4-.9-1.8-1.4.6-.7.8-1.1 1.4-1.9.4.4.9.8 1.5 1.2.6.4 1.2.7 1.8.9 1.2.4 1.9.3 2-.4.1-.3-.1-.6-.4-.8-.3-.2-.8-.5-1.5-.8-.8-.4-1.5-.7-2-1.1-.5-.3-.9-.8-1.2-1.3s-.4-1.2-.3-2c.1-.7.4-1.2.9-1.6s1.1-.6 1.9-.7 1.6.1 2.6.4c.7.2 1.4.5 2.1.9.7.4 1.2.8 1.6 1.2-.6.7-.8 1.1-1.4 1.8-.8-.8-1.7-1.4-2.8-1.7-.6-.2-1.1-.3-1.5-.2-.3.1-.6.3-.6.5-.1.3.1.6.4.8.3.2.8.5 1.6.9s1.5.8 2 1.1c.5.3.9.8 1.2 1.3s.4 1.2.2 2c-.1.6-.4 1.2-.9 1.5-.5.4-1.1.6-1.9.7-.8 0-1.7-.1-2.7-.4-.7-.1-1.5-.5-2.2-.9zM530.9 230.9c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.5-.8-.2-1.4-.6-2-1-.5-.4-.9-1-1.1-1.5-.2-.6-.3-1.2-.1-1.8.2-1 .7-1.6 1.5-2 .8-.3 2-.3 3.5.2.9.3 1.4.4 2.3.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.2-1.1-.2-1.6-.2-.6 0-1 .1-1.5.3-.3-1-.4-1.5-.7-2.4.6-.2 1.4-.3 2.2-.3s1.6.1 2.5.4c1.6.5 2.8 1.2 3.5 2.2zm-3.9 6.5c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.4-2-.6-1.2-.4-1.9-.1-2 .7-.1.4 0 .7.3 1.1.3.3.6.5 1.2.7.4.1.9.1 1.3 0zM545.6 233.4c-1.1 5.7-1.6 8.5-2.7 14.1-1.2-.2-1.8-.3-3-.6.4-1.9.6-2.9.9-4.8-.9.7-2 .9-3.3.6-1-.2-1.8-.7-2.5-1.3-.7-.6-1.2-1.4-1.5-2.3s-.3-1.9-.1-3 .6-1.9 1.2-2.6c.6-.7 1.3-1.2 2.2-1.4.9-.2 1.8-.2 2.8 0 1.4.3 2.4 1 3 2.1.1-.5.1-.7.2-1.2 1.1.1 1.7.2 2.8.4zm-5.1 6.6c.6-.4 1-1.1 1.1-1.9.2-.9 0-1.6-.4-2.3-.4-.6-1-1-1.7-1.2-.8-.2-1.4-.1-2 .3s-1 1-1.1 1.9c-.2.9-.1 1.6.3 2.3.4.6 1 1.1 1.7 1.2.9.2 1.5.1 2.1-.3zM559 235.1c-.8 4.2-1.2 6.2-2 10.4-1.2-.1-1.8-.1-2.9-.2.1-.5.1-.7.2-1.2-.5.4-1 .7-1.7.9-.6.2-1.2.2-1.9.1-1.4-.2-2.4-.7-3.1-1.6-.7-.9-.8-2.1-.5-3.7.4-2.3.7-3.5 1.1-5.9l3 .5c-.4 2.2-.6 3.3-1 5.4-.3 1.7.2 2.6 1.7 2.8.7.1 1.4-.1 1.9-.5s.9-1.1 1.1-2c.4-2.1.6-3.1 1-5.1 1.3 0 1.9 0 3.1.1zM565.1 231.2c1.3 0 2 0 3.4-.1-1.7 1.2-2.5 1.7-4.2 2.9h-2.4c1.3-1.2 1.9-1.7 3.2-2.8zm-3.2 4h3.1c-.8 4.2-1.2 6.2-2 10.4h-3.1c.8-4.1 1.2-6.2 2-10.4z"
                    />
                </g>
            </g>
            <g id="sala_plumerillo">
                <path
                    id="color_sala_plumerillo"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: Sala_Plumerillo.color,
                        stroke: "#1a1a18",
                        strokeWidth: 6,
                        strokeMiterlimit: 10,
                    }}
                    d="M1020.8 652.4H1545.4V233h-524.6z"
                />
                <text transform="translate(1232.984 393.238)" className="st2 st3 st21">
                    {"SALA"}
                </text>
                <text transform="translate(1220 450.448)" className="st2 st3 st21">
                    {"Raizen"}
                </text>
                <g id="bandera_plumerillo" display={Sala_Plumerillo.display}>
                    <path
                        id="palo_2_"
                        d="M1355.1 601.3c-1.1-.2-1.8-1.3-1.6-2.4l27.9-146.8c.2-1.1 1.3-1.8 2.4-1.6 1.1.2 1.8 1.3 1.6 2.4l-27.9 146.8c-.2 1.1-1.3 1.8-2.4 1.6z"
                    />
                    <path
                        id="fondo_bandera_2_"
                        className="st10"
                        d="M1487.3 557.9c-6.3 1.5-17.8 4.4-29.5-.7-28-12-59.3-26.1-89.7-22 4.5-23.8 9.1-47.7 13.6-71.5 40-2.3 80.2 20.2 119.2 22.6-4.6 23.9-9.1 47.7-13.6 71.6z"
                    />
                    <path
                        id="borde_bandera_2_"
                        d="M1465.7 560.8c-4.5-.8-9.1-2.3-13.7-4.2l-2.3-1c-25.8-11-52.4-22.3-81.4-18.4-.6.1-1.3-.1-1.7-.6s-.6-1.1-.5-1.8l13.6-71.5c.2-.9.9-1.6 1.9-1.6 22.6-1.3 45.4 5.2 67.4 11.5 17.2 4.9 35 10 52.1 11.1.6 0 1.1.3 1.5.8s.5 1 .4 1.6l-13.6 71.5c-.1.7-.6 1.3-1.3 1.5-6.7 2.3-14.3 2.7-22.4 1.1zm-65.4-26.4c17.7 3.4 34.5 10.5 51 17.6l2.3 1c11.6 5 22.9 6.2 31.9 3.4l12.9-68.1c-16.8-1.4-34-6.3-50.6-11.1-21.2-6.1-43.1-12.3-64.5-11.5l-12.8 67.3c10.3-1.2 20.2-.5 29.8 1.4zm86.9 23.5z"
                    />
                    <path
                        className="st11"
                        d="m1395.4 502-.5 2.5c-4.3-.4-6.4-.4-10.8-.2 1-5.4 1.5-8.1 2.6-13.5 4.3-.2 6.4-.1 10.5.2l-.5 2.5c-2.9-.2-4.4-.3-7.3-.3-.2 1.2-.3 1.8-.6 2.9 2.6 0 3.9 0 6.5.2-.2 1-.3 1.5-.5 2.4-2.6-.2-3.9-.2-6.5-.2-.2 1.3-.4 1.9-.6 3.1 3.2.1 4.7.2 7.7.4zM1398.2 504.7c-.8-.3-1.4-.6-1.8-1 .6-.8.9-1.2 1.4-2.1.4.3.9.7 1.6.9.6.3 1.3.4 1.9.5 1.3.2 2 0 2.1-.7.1-.3-.1-.5-.4-.7s-.9-.4-1.6-.6c-.8-.2-1.5-.5-2-.7s-1-.6-1.3-1.1c-.3-.5-.4-1.1-.3-1.9.1-.7.4-1.2.9-1.7s1.1-.8 1.9-1 1.7-.2 2.7-.1c.7.1 1.5.3 2.2.6.7.3 1.3.6 1.7 1-.6.8-.8 1.2-1.4 2-.8-.7-1.8-1.1-2.9-1.3-.6-.1-1.2-.1-1.5.1-.4.1-.6.3-.6.6-.1.3.1.6.4.7.3.2.9.4 1.6.6.8.3 1.5.5 2 .8s.9.6 1.2 1.1c.3.5.4 1.1.3 1.9-.1.6-.4 1.2-.9 1.6s-1.1.7-1.9.9c-.8.2-1.7.2-2.7 0-.9.1-1.8-.1-2.6-.4zM1414.3 507.3c-.3.1-.7.2-1.2.2-.4 0-.9 0-1.4-.2-1.2-.3-2.1-.8-2.7-1.6-.6-.8-.7-1.8-.5-3 .3-1.7.5-2.6.8-4.3-.6-.1-1-.2-1.6-.3.2-.9.3-1.4.4-2.3.6.1 1 .2 1.6.3l.5-2.5c1.2.2 1.8.4 3 .6l-.5 2.5c1 .2 1.5.3 2.6.6-.2.9-.3 1.4-.4 2.3-1-.2-1.5-.4-2.6-.6-.3 1.7-.5 2.5-.8 4.2-.1.4 0 .8.1 1.1.2.3.5.5.9.6.5.1.9.1 1.3-.1.2 1.1.3 1.6.5 2.5zM1425.4 501c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.6-.8-.2-1.4-.5-2-1-.5-.4-.9-.9-1.1-1.5-.2-.6-.3-1.1-.2-1.7.2-1 .7-1.6 1.5-2 .8-.4 2-.4 3.5.1.9.3 1.4.4 2.4.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.1-1.1-.2-1.7-.2s-1.1.2-1.5.4c-.3-1-.4-1.4-.7-2.4.6-.3 1.4-.4 2.2-.4.8 0 1.6.1 2.5.3 1.8.5 2.9 1.2 3.6 2.2zm-3.9 6.4c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.3-2-.6-1.2-.3-1.9-.1-2.1.7-.1.4 0 .7.3 1 .3.3.6.5 1.2.7.5.3 1 .3 1.4.1zM1428.6 511.7c-.8-.5-1.4-.9-1.8-1.4.6-.7.8-1.1 1.4-1.9.4.4.9.8 1.5 1.2.6.4 1.2.7 1.8.9 1.2.4 1.9.3 2-.4.1-.3-.1-.6-.4-.8-.3-.2-.8-.5-1.5-.8-.8-.4-1.5-.7-2-1.1-.5-.3-.9-.8-1.2-1.3-.3-.5-.4-1.2-.3-2 .1-.7.4-1.2.9-1.6s1.1-.6 1.9-.7 1.6.1 2.6.4c.7.2 1.4.5 2.1.9.7.4 1.2.8 1.6 1.2-.6.7-.8 1.1-1.4 1.8-.8-.8-1.7-1.4-2.8-1.7-.6-.2-1.1-.3-1.5-.2-.3.1-.6.3-.6.5-.1.3.1.6.4.8.3.2.8.5 1.6.9s1.5.8 2 1.1c.5.3.9.8 1.2 1.3.3.5.4 1.2.2 2-.1.6-.4 1.2-.9 1.5-.5.4-1.1.6-1.9.7-.8 0-1.7-.1-2.7-.4-.7-.1-1.5-.5-2.2-.9zM1452.5 509.2c.7 1 .9 2.3.6 3.8-.5 2.4-.7 3.6-1.1 5.9-1.1-.3-1.7-.5-2.8-.8.1-.5.1-.8.2-1.3-.7.8-1.9 1-3.4.5-.8-.2-1.4-.6-2-1-.5-.4-.9-1-1.1-1.5-.2-.6-.3-1.2-.1-1.8.2-1 .7-1.6 1.5-2 .8-.3 2-.3 3.5.2.9.3 1.4.4 2.3.7.1-.7 0-1.2-.3-1.7s-.9-.8-1.7-1c-.5-.2-1.1-.2-1.6-.2-.6 0-1 .1-1.5.3-.3-1-.4-1.5-.7-2.4.6-.2 1.4-.3 2.2-.3.8 0 1.6.1 2.5.4 1.6.5 2.8 1.2 3.5 2.2zm-3.9 6.5c.4-.1.8-.4 1-.8.1-.4.1-.6.2-1.1-.8-.2-1.2-.4-2-.6-1.2-.4-1.9-.1-2 .7-.1.4 0 .7.3 1.1.3.3.6.5 1.2.7.4.1.9.1 1.3 0zM1467.2 511.7c-1.1 5.7-1.6 8.5-2.7 14.1-1.2-.2-1.8-.3-3-.6.4-1.9.6-2.9.9-4.8-.9.7-2 .9-3.3.6-1-.2-1.8-.7-2.5-1.3-.7-.6-1.2-1.4-1.5-2.3-.3-.9-.3-1.9-.1-3 .2-1.1.6-1.9 1.2-2.6.6-.7 1.3-1.2 2.2-1.4.9-.2 1.8-.2 2.8 0 1.4.3 2.4 1 3 2.1.1-.5.1-.7.2-1.2 1.1.1 1.7.2 2.8.4zm-5.1 6.6c.6-.4 1-1.1 1.1-1.9.2-.9 0-1.6-.4-2.3-.4-.6-1-1-1.7-1.2-.8-.2-1.4-.1-2 .3-.6.4-1 1-1.1 1.9-.2.9-.1 1.6.3 2.3.4.6 1 1.1 1.7 1.2.9.2 1.5.1 2.1-.3zM1480.6 513.4c-.8 4.2-1.2 6.2-2 10.4-1.2-.1-1.8-.1-2.9-.2.1-.5.1-.7.2-1.2-.5.4-1 .7-1.7.9-.6.2-1.2.2-1.9.1-1.4-.2-2.4-.7-3.1-1.6-.7-.9-.8-2.1-.5-3.7.4-2.3.7-3.5 1.1-5.9l3 .5c-.4 2.2-.6 3.3-1 5.4-.3 1.7.2 2.6 1.7 2.8.7.1 1.4-.1 1.9-.5s.9-1.1 1.1-2c.4-2.1.6-3.1 1-5.1 1.3 0 1.9 0 3.1.1zM1486.7 509.5c1.3 0 2 0 3.4-.1-1.7 1.2-2.5 1.7-4.2 2.9h-2.4c1.3-1.2 1.9-1.7 3.2-2.8zm-3.2 4h3.1c-.8 4.2-1.2 6.2-2 10.4h-3.1c.8-4.1 1.2-6.2 2-10.4z"
                    />
                </g>
            </g>
            <g id="puertas">
                <path
                    id="entrada_hall-puente_del_inca"
                    className="st22"
                    style={{
                        fill: Sala_Puente_Del_Inca.color,
                    }}
                    d="M262.3 448h6.2v34.9h-6.2z"
                />
                <path
                    id="entrada_hall-horcones"
                    className="st22"
                    style={{
                        fill: Sala_Horcones.color,
                    }}
                    d="M613 401.8h35.5v6.4H613z"
                />
                <path
                    id="entrada_hall-Asensor"
                    className="st22"
                    style={{
                        fill: Hall_Segundo_Piso.color,
                    }}
                    d="M943.9 932.6h35.5v6.4h-35.5z"
                />
                <path
                    id="entrada_hall-sanitarios"
                    className="st22"
                    style={{
                        fill: colores.color_sala_desactivada,
                    }}
                    d="M275.3 698h35.5v6.3h-35.5z"
                />
                <path
                    id="entrada_hall-plumerillo"
                    style={{
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: Sala_Plumerillo.color,
                    }}
                    d="M1016.8 247.6h7.1v71.6h-7.1z"
                />
                <path
                    id="entrada_hall-vendimie"
                    className="st22"
                    style={{
                        fill: Sala_Vendimia.color,
                    }}
                    d="M1299 699.5h84.9v6.3H1299z"
                />
            </g>
            <text
                id="titulo_1_"
                transform="translate(501.149 148.02)"
                className="st11 st3"
                style={{
                    fontSize: 90,
                }}
            >
                {"SEGUNDO PISO"}
            </text>
        </svg>
    )
}